const PortDirection = {
  In: true,
  Out: false
};

export default PortDirection;
